import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import './BasicInformationLine.scss';
import { useRouteMatch } from 'react-router';
import { Tooltip } from 'antd';

const BasicInformationLine = ({ buttons }) => {
  const {
    params: { noticeId, fileId },
  } = useRouteMatch([
    '/Debts/file/:fileId/notice/:noticeId',
    '/Debts/file/:fileId',
  ]) || {
    params: {},
  };
  const openedFile = useSelector((store) => store.debtsStore.files)?.find(
    (file) => {
      return +file.fileId === +fileId;
    }
  );
  const notice = openedFile?.notices?.find((notice) => {
    return +notice.id === +noticeId;
  });
  return (
    <div className="full_information">
      <div className="full_information-part_row">
        <span className="full_information-item">
          {noticeId ? 'Создано' : 'Загружен'}:{' '}
          <span className="full_information-item-info">
            {noticeId ? notice?.workerName : openedFile?.workerName}
          </span>
        </span>
        <div
          className="full_information-item"
          style={{ display: 'flex', gap: 5 }}
        >
          Файл:
          <Tooltip title={noticeId ? notice?.fileName : openedFile?.fileName}>
            <div className="full_information-item-info contentMaxWidth">
              {noticeId ? notice?.fileName : openedFile?.fileName}
            </div>
          </Tooltip>
        </div>
        <span className="full_information-item">
          Дата {noticeId ? 'создания' : 'загрузки'}:{' '}
          <span className="full_information-item-info">
            {noticeId
              ? moment(notice?.createTime).format('DD.MM.YYYY HH:mm')
              : moment(openedFile?.uploadTime).format('DD.MM.YYYY HH:mm')}
          </span>
        </span>
      </div>
      <div className="full_information-part_row">{buttons}</div>
    </div>
  );
};

export default BasicInformationLine;
